export default __webpack_public_path__ + "static/media/laptop_dashboard.01240325.png";